import { f as flow } from '../ReadonlyNonEmptyArray-3599e877.js';
import { Node_Type } from 'ricos-schema';
import { getExtractor } from '../extractor-infra.js';
import '../Option-87dfe66c.js';
import '../index-907c0cc3.js';
import '../ReadonlyRecord-da7aaead.js';
import '../string-04247af1.js';

const nodesAccessor = (node) => Array.isArray(node.nodes) ? node.nodes : [];
const getRootNode = (nodes) => Array.isArray(nodes) ? {
  id: "root",
  type: Node_Type.UNRECOGNIZED,
  nodes
} : nodes;
const extract = flow(
  getRootNode,
  getExtractor(nodesAccessor)
);

export { extract };
//# sourceMappingURL=extract.js.map
